import { Spinner, SpinnerSizes } from '@polestar/component-warehouse-react';
import { RouteDefinition, useAuth } from '@polestar/shared-front-myorder';
import { Route, Routes } from 'react-router';

type AppRouterProps = {
  routes: RouteDefinition[];
  getView: (routeDefinition: RouteDefinition | null) => JSX.Element;
  getNotFoundView: () => JSX.Element;
};

export const AppRouter = ({ routes, getView }: AppRouterProps) => {
  const { isLoading } = useAuth();
  return (
    <Routes>
      {isLoading && <Route path="*" element={<Spinner size={SpinnerSizes.medium} />} />}
      {routes.map((route) => {
        return <Route key={`view.${route.name}`} path={route.path} element={getView(route)} />;
      })}
    </Routes>
  );
};
